import Clipboard from 'clipboard';

Vue.component("share_new", {
  props: {
		share_text: ''
  },
  template: `
	<div>
		<!--  分享   -->
		<div class="share-container-mask" v-if="showShare&&share_text">
			<div class="mask_box" @click="handleClose"></div>
			<div class="share-select-container">
				<div class="share-select-title">
					<span>朋友圈文案</span>
					<div class="share-select-tips" @click="handleStep">如何使用?</div>
				</div>
				<div class="share-select-text-box" @click="clickTxtBox">
					<div class="share-select-text" v-html="share_text" :style="{color:isChecked?'#262626':'#A3AFBF'}"></div>
					<div class="share-select-icon">
						<img :src="isChecked?'https://assets.rurushishi.com/yq-rs-h5/t1/img/checkbox-yes.png':'https://assets.rurushishi.com/yq-rs-h5/t1/img/checkbox-no.png'">
					</div>
				</div>
				<div class="share-select-btn-box">
					<div v-if="false" class="share-select-btn-item" @click="handlePoster">海报分享</div>
					<div v-if="isChecked" class="share-select-btn-item btn-copy" id="copyBtn" :data-clipboard-text="copyTxt">复制配文转发</div>
					<div v-else class="share-select-btn-item btn-copy" @click="clickOffHandShare">立即转发</div>
				</div>
			</div>
		</div>
		<div class="share-container-mask" v-if="showStep">
			<div class="share-select-container share-select-container-pd">
				<div class="share-step-container">
					<div class="share-step-title share-step-1">
						点击右上角 <span>···</span> 按钮（下图红色区域)
					</div>
					<div class="share-step-img share-step-line">
						<img src="https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/share-01.png">
					</div>
					<div class="share-step-title share-step-2">
						选择 发送给朋友 或 分享到朋友圈
					</div>
					<div class="share-step-img share-step-line">
						<img src="https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/share-02.png">
					</div>
					<div class="share-step-title share-step-3">
						长按朋友圈的输入框（下图红色区域），在弹框中选择“粘贴”操作，再点击发表完成分享。
					</div>
					<div class="share-step-img">
						<img src="https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/share-03.png">
					</div>
				</div>
				<div class="share-step-btn" @click="handleShare">我知道了</div>
			</div>
		</div>
		<div class="share-container-mask" v-if="showTips" @click="handleClose">
			 <div class="share-tips-box">
				 <div class="share-tips-arrow">
					 <img src="https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/share-arrow.png">
				 </div>
				 <div>
					 <div class="share-tips-box-text-big">分享优质内容</div>
					 <div class="share-tips-box-text-sml">请让更多朋友看到</div>
				 </div>
			 </div>
			 <div v-if="false" class="share-tips--bottom-btn" @click="handlePoster">
			 <img src="https://assets.rurushishi.com/yq-rs-h5/t1/save-img.png">
			 海报分享，更多惊喜</div>
		</div>
  </div>`,
	data() {
	  return {
			showShare: true,
			showStep: false,
			showTips: false,
			isChecked:true
		}
	},
	created() {
		let _t = this;
		let clipBoard = new Clipboard('#copyBtn');
		clipBoard.on('success', function () {
			_t.showStep = false
			_t.showShare = false
			_t.showTips = true
		});
		clipBoard.on('error', function () {
			alert('复制失败，请手动复制')
		})
		if(this.share_text==""){
			this.showTips=true;
		}
	},
	computed:{
		copyTxt(){
			return this.share_text?.replace(/<br\/>/g, '\n') || '';
		}
	},
  methods: {
		clickOffHandShare(){
			this.showStep = false
			this.showShare = false
			setTimeout(() => {
				this.showTips = true
			}, 0);
		},
		clickTxtBox(){
			this.isChecked=!this.isChecked;
		},
		handleShare() { //显示分享
			this.showShare = true
			this.showStep = false
			this.showTips = false
		},
    handleStep() { // 如何使用
			this.showShare = false
			this.showStep = true
			this.showTips = false
    },
		handleClose() {
			this.handleShare()
			this.$emit("close");
		},
		handlePoster() {
			console.log('制作海报！')
			this.$emit("makeposter");
		}
  }
})
